export function TestWeek3Simple() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Week 3 Feature Test Page - Simple</h1>
      <p>This is a simplified test page to verify basic React functionality.</p>
      <button onClick={() => alert('Button clicked!')}>
        Test Button
      </button>
    </div>
  );
}